import { AiOutlinePrinter } from 'react-icons/ai';
import { Fragment } from 'react/jsx-runtime';
import informerLogo from '../../../../../../../assets/images/logo_black.png';
import { Button } from '../../../../../../../components/button/button';
import { Modal, ModalProps } from '../../../../../../../components/modal/modal';
import { QrTextPlacementType } from './helpers';
import { PrintContainer } from './print-container/print-container';
import { WrappedQrCode } from './print-container/wrapped-qr-code/wrapped-qr-code';
import s from './print-qr-modal.module.css';
import { PrintSettings } from './print-settings/print-settings';
import { usePrintQrModal } from './use-print-qr-modal';

export const PrintQrModal = (props: ModalProps) => {
  const {
    duplicatedQrCodes,
    handlePrint,
    t,
    componentRef,
    size,
    setSize,
    selectedTemplate,
    qrCodes,
    setQrCodes,
    duplicate,
    setDuplicate,
    setTemplate,
    setVariant,
    template,
    variant,
    logo,
    handleUploadLogo,
    setTextPlacement,
    textPlacement,
    setFrom,
    from,
    maxToPrint,
    background,
    setBackground,
    dots,
    setDots,
    textColor,
    setTextColor,
  } = usePrintQrModal();

  return (
    <Modal className={s.feature} {...props} title={t('Печать QR-кодов')}>
      <div className={s.content}>
        <PrintSettings
          codes={{ onChange: setQrCodes, value: qrCodes }}
          size={{ onChange: setSize, value: size }}
          template={{ onChange: setTemplate, value: template }}
          variant={{ onChange: setVariant, value: variant, logo, onUploadLogo: handleUploadLogo }}
          duplicate={{ onChange: setDuplicate, value: duplicate }}
          text={{ onChange: setTextPlacement, value: textPlacement }}
          from={{ onChange: setFrom, value: from }}
          background={{ onChange: setBackground, value: background }}
          dots={{ onChange: setDots, value: dots }}
          textColor={{ onChange: setTextColor, value: textColor }}
        />
        <PrintContainer ref={componentRef} className={s.list}>
          {duplicatedQrCodes.map((qrCode, index) => (
            <Fragment key={qrCode.id + index}>
              <WrappedQrCode
                data={qrCode.id}
                label={qrCode.value}
                size={size}
                background={background}
                dots={dots}
                textColor={textColor}
                img={selectedTemplate?.image}
                crop={selectedTemplate?.crop}
                logo={variant.id === 'empty' ? undefined : logo || informerLogo}
                labelPosition={textPlacement.id as QrTextPlacementType}
              />
            </Fragment>
          ))}
        </PrintContainer>
      </div>
      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose}>
          {t('Назад')}
        </Button>
        <Button onClick={handlePrint}>
          <AiOutlinePrinter />
          {t('Печать')} {`${duplicatedQrCodes.length} / ${maxToPrint}`}
        </Button>
      </div>
    </Modal>
  );
};
